import { render } from "./VdiContactView.vue?vue&type=template&id=2e741a8a&scoped=true"
import script from "./VdiContactView.vue?vue&type=script&lang=js"
export * from "./VdiContactView.vue?vue&type=script&lang=js"

import "./VdiContactView.vue?vue&type=style&index=0&id=2e741a8a&scoped=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e741a8a"]])

export default __exports__